/* build-version: 2026-03-08-v1 */
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Redirect, Route, useLocation } from "react-router-dom";
import { useSnackbar } from "notistack";
import AuthLayout from "../pages/_layouts/auth";
import DefaultLayout from "../pages/_layouts/default";
import api from "../services/api";
import { store } from "../store";
import { signOut } from "../store/modules/auth/actions";

export default function RouteWrapper({
  component: Component,
  isPrivate,
  isAdm,
  isLab,
  standalone,
  ...rest
}) {
  const { signed, token } = store.getState().auth;
  const dispatch = useDispatch();
  const location = useLocation();
  const { enqueueSnackbar } = useSnackbar();

  if (signed && token && typeof token === 'string') {
    const payload = JSON.parse(atob(token.split(".")[1]));
    const time_now = Math.round(new Date().getTime() / 1000);
    const time_expired = payload.exp;
    const leeway = 600;

    if (time_now - leeway - time_expired > 1) {
      enqueueSnackbar("Tempo de sessão expirou!", { variant: "warning" });
      dispatch(signOut());
    }
  }

  // Redirecionar users logados APENAS de rotas de autenticação (login, cadastro)
  // para a home. Rotas públicas informativas (ajuda, landing pages) continuam acessíveis.
  const authOnlyRoutes = [
    "/login",
    "/cadastro",
    "/empresa-cadastro",
    "/select-cadastro",
    "/forgot",
    "/recuperar-acesso",
  ];

  if (signed && authOnlyRoutes.includes(location.pathname)) {
    return <Redirect to="/" />;
  }

  // Condição para renderizar layout
  const Layout = (!signed || standalone) ? AuthLayout : DefaultLayout;
  return (
    <Route
      {...rest}
      render={(props) => (
        <Layout>
          <Component {...props} />
        </Layout>
      )}
    />
  );
}

RouteWrapper.propTypes = {
  isPrivate: PropTypes.bool,
  isAdm: PropTypes.bool,
  component: PropTypes.oneOfType([PropTypes.element, PropTypes.func])
    .isRequired,
};

RouteWrapper.defaultProps = {
  isPrivate: false,
  isAdm: false,
};
